import React, { useState } from 'react';
import api from '@/auth/api';
import { alertError, alertSuccess } from '@/components/Alert';

const Add = ({ agencyList, onSuccess }) => {
  const [formData, setFormData] = useState({
    agency: '',
    title: '',
    detailFirstPage: '',
    detailEndPage: '',
    Point: '',
    multipleOfPoints: false,
    BiddingImage: null,
  });

  const [previewImage, setPreviewImage] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      const file = files[0];
      setFormData((prev) => ({ ...prev, [name]: file }));
      if (file) setPreviewImage(URL.createObjectURL(file));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    const detailFirstPageArray = formData.detailFirstPage.split(',').map(i => i.trim());
    const detailEndPageArray = formData.detailEndPage.split(',').map(i => i.trim());

    for (const key in formData) {
      if (key === 'detailFirstPage') {
        data.append(key, JSON.stringify(detailFirstPageArray));
      } else if (key === 'detailEndPage') {
        data.append(key, JSON.stringify(detailEndPageArray));
      } else {
        data.append(key, formData[key]);
      }
    }

    try {
      await api.post('/redeem/panel/bidding', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alertSuccess('Bidding added successfully');
      onSuccess()
      setFormData({
        agency: '',
        title: '',
        detailFirstPage: '',
        detailEndPage: '',
        Point: '',
        multipleOfPoints: false,
        BiddingImage: null,
      });
      setPreviewImage(null)
    } catch (err) {
      alertError(err?.response?.data?.errors || 'Something went wrong.');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md p-3 mx-auto bg-white rounded-md shadow text-sm space-y-2"
    >

<input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1.5 border rounded"
        required
      />
      <select
        name="agency"
        value={formData.agency}
        onChange={handleChange}
        className="w-full p-1.5 border rounded"
        required
      >
        <option value="" disabled>Select Agency</option>
        {agencyList.map((agency) => (
          <option key={agency.id} value={agency.id}>{agency.agencyName}</option>
        ))}
      </select>

     

      <div className="grid grid-cols-1 gap-2">
        <textarea
          name="detailFirstPage"
          placeholder="Detail First Page (comma separated)"
          value={formData.detailFirstPage}
          onChange={handleChange}
          rows={3}
          className="w-full p-1.5 border rounded resize-none"
          required
        />
        <textarea
          name="detailEndPage"
          placeholder="Detail End Page (comma separated)"
          value={formData.detailEndPage}
          onChange={handleChange}
          rows={3}
          className="w-full p-1.5 border rounded resize-none"
          required
        />
      </div>

      <div className="flex gap-2 items-center">
        <input
          type="number"
          name="Point"
          placeholder="Points"
          value={formData.Point}
          onChange={handleChange}
          className="w-full p-1.5 border rounded"
          required
        />
        <label className="flex items-center gap-1 whitespace-nowrap">
          <input
            type="checkbox"
            name="multipleOfPoints"
            checked={formData.multipleOfPoints}
            onChange={handleChange}
          />
          <span>Multiple</span>
        </label>
      </div>

      <input
        type="file"
        name="BiddingImage"
        accept="image/*"
        onChange={handleChange}
        className="w-full p-1.5 border rounded"
        required
      />

      <div className="flex items-center gap-4">
        {previewImage && (
          <img
            src={previewImage}
            alt="Preview"
            className="w-20 h-20 object-cover border rounded"
          />
        )}
        <button
          type="submit"
          className="flex-1 py-2 text-white rounded bg-[var(--mainCol)] hover:bg-[var(--mainColHover)] text-sm"
        >
          Add Bidding
        </button>
      </div>
    </form>
  );
};

export default Add;
